import React from "react";
import { Link, useParams } from "react-router-dom";
import useWaitlistModal from "./useWaitlistModal";
import Header from "./Header";
import Footer from "./Footer";
import WaitlistModal from "./WaitlistModal";
import jidokaLogo from "./assets/jidoka-logo.png";
import multilingualImage from "./assets/multilingual.png";
import jidokaCaseStudy1 from "./assets/Jidoka_casestudy_1.png";
import jidokaCaseStudy5 from "./assets/Jidoka_casestudy_5.png";
import discovery from "./assets/discovery-stat-light-flipped.png";

const CaseStudyDetail = () => {
  const { id } = useParams();
  const {
    showWaitlistModal,
    formData,
    isSubmitting,
    isSubmitted,
    formError,
    openWaitlistModal,
    closeWaitlistModal,
    handleInputChange,
    handleSubmit,
  } = useWaitlistModal();

  // Only Jidoka Technologies for now
  if (id !== "jidoka-technologies") {
    return (
      <div className="min-h-screen bg-gray-100">
        <Header onOpenWaitlist={openWaitlistModal} />
        <main className="bg-gray-100 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-3xl font-black text-slate-900 mb-4">
              Case Study Not Found
            </h1>
            <Link
              to="/case-studies"
              className="text-jindo-orange font-bold hover:underline"
            >
              Back to Case Studies
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Header onOpenWaitlist={openWaitlistModal} />

      <main>
        {/* Hero Section */}
        <section className="bg-gray-100 pt-8 sm:pt-8 py-12 sm:py-16 border-b border-slate-300">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
            {/* Logo and Tag */}
            <div className="flex justify-between items-center mb-10 sm:mb-12">
              {/* Back Link */}
            <div>
              <Link
                to="/case-studies"
                className="inline-flex items-center gap-2 text-jindo-orange font-bold text-sm hover:underline"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
                Back to Case Studies
              </Link>
            </div>
              {/* <div className="text-sm text-slate-600">Customer story</div> */}
            </div>

            
           <div className="flex flex-col items-center justify-center">
            <div className="h-6 sm:h-8 ">
              <img
                src={jidokaLogo}
                alt="Jidoka Technologies"
                className="h-full w-auto object-contain justify-center mx-auto"
              />
            </div>
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-black text-slate-900 leading-tight my-2 mb-6 text-center">
              Jidoka Technologies
            </h1>
            </div>
            <p className="text-base sm:text-lg lg:text-xl font-bold text-slate-700 leading-relaxed mb-6 text-center">
              From sales call to shop floor: faster handoffs, shared context, no rediscovery
            </p>
            {/* <p className="text-lg text-slate-700 leading-relaxed max-w-3xl mb-10">
              Jidoka Technologies runs three‑ to four‑month technical
              evaluations across regional plants and languages. Here's how Jindo
              keeps every detail from a sales call intact all the way to the
              shop floor.
            </p> */}

            {/* Meta Strip */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 pt-10 border-t border-slate-300">
              <div>
                <div className="text-xs text-slate-600 mb-2">Industry</div>
                <div className="font-bold text-slate-900">
                  Industrial AI / machine vision
                </div>
              </div>
              <div>
                <div className="text-xs text-slate-600 mb-2">Challenge</div>
                <div className="font-bold text-slate-900">
                  Technical detail lost between presales and delivery
                </div>
              </div>
              <div>
                <div className="text-xs text-slate-600 mb-2">Solution</div>
                <div className="font-bold text-slate-900">
                  Jindo as an always‑on account memory layer
                </div>
              </div>
              <div>
                <div className="text-xs text-slate-600 mb-2">Result</div>
                <div className="font-bold text-slate-900">
                  Day‑zero plant execution, no recording bots
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stat Strip
        <section className="bg-gray-200 border-t border-b border-slate-300 py-10 sm:py-12">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-10">
              <div>
                <div className="text-6xl sm:text-7xl font-black text-jindo-orange mb-3">
                  0
                </div>
                <div className="text-sm text-slate-700 max-w-xs">
                  days of floor rediscovery for delivery PMs
                </div>
              </div>
              <div>
                <div className="text-6xl sm:text-7xl font-black text-jindo-orange mb-3">
                  0
                </div>
                <div className="text-sm text-slate-700 max-w-xs">
                  visible recording bots in technical reviews
                </div>
              </div>
              <div>
                <div className="text-6xl sm:text-7xl font-black text-jindo-orange mb-3">
                  0
                </div>
                <div className="text-sm text-slate-700 max-w-xs">
                  MP4s added to the video graveyard
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <div className="rounded-lg overflow-hidden shadow-xl max-w-3xl mx-auto">
              <img
                src={discovery}
                alt="Jindo solution overview"
                className="w-full h-auto"
              />
            </div>

        {/* Quote Block */}
        <section className="bg-slate-900 text-white py-12 sm:py-16 ">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 ">
            <blockquote className="text-2xl sm:text-3xl font-medium leading-relaxed mb-6 max-w-3xl  justify-center">
              "When technical discovery specs are captured with 100% fidelity on
              day one, our engineering team builds Proofs‑of‑Concept that match
              plant realities immediately — eliminating weeks of redundant floor
              discovery."
            </blockquote>
            <p className="text-sm text-slate-400">
              <span className="text-white font-semibold">
                Vinodh Venkatesan
              </span>{" "}
              — CRO & Co‑founder, Jidoka Technologies
            </p>
          </div>
        </section>

        {/* The Company */}
        <section className="py-16 sm:py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              The Company
            </h2>
            <div className="grid lg:grid-cols-[1.5fr_1fr] gap-10 items-start">
              <p className="text-lg text-slate-700 leading-relaxed">
                Jidoka Technologies builds AI‑powered vision inspection for
                high‑speed manufacturing and logistics. Its KOMPASS™ and NAGARE
                engines catch defects and validate assembly in real time for
                automotive, FMCG, pharma, and electronics clients. For Jidoka's
                customers, First‑Time‑Right isn't a slogan - it's the standard
                the whole line is built around.
              </p>
              <div className="border-l-4 border-jindo-orange pl-5">
                <div className="text-5xl font-black text-slate-900 mb-2">
                  300M+
                </div>
                <div className="text-sm text-slate-700">
                  products inspected every day across Jidoka's customer base
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* The Problem */}
        <section className="py-16 sm:py-20 bg-gray-200 border-t border-b border-slate-300">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              The Problem: technical context kept getting lost
            </h2>
            <p className="border-l-4 border-sky-600 pl-5 text-slate-700 mb-10 max-w-4xl">
              A Jidoka deal runs three to four months of presales evaluation,
              with Plant Managers, Quality Directors, and Automation Engineers
              weighing in across regional plants - often switching between
              technical English, Tamil, Marathi, Hindi, German, and Japanese in
              the same conversation.
            </p>
            <div className="grid sm:grid-cols-2 gap-8 lg:gap-10">
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  The handoff gap
                </h3>
                <p className="text-slate-700">
                  Everything a Plant Manager mentioned about conveyor speeds,
                  lighting, or camera placement lived only in the presales
                  team's heads and notes. By the time a deal closed, that
                  context had thinned out or vanished — Delivery PMs spent their
                  first week rediscovering what had already been said, on
                  someone else's clock.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  The information capture problem
                </h3>
                <p className="text-slate-700">
                  Call recording hit three walls at once: plant executives
                  didn't want a visible bot in sensitive technical meetings,
                  nobody had hours to wade through raw video for one comment
                  about lighting tolerances, and storing it all wasn't cheap.
                  The archive grew, but nobody ever opened it.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* The Solution */}
        <section className="py-16 sm:py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              The Solution: Jindo as the GTM memory and intelligence layer
            </h2>
            <p className="text-lg text-slate-700 mb-10 max-w-4xl">
              Jidoka layered Jindo quietly on top of its existing stack — Zoho
              CRM, Gmail, and Google Calendar — and let it become the connective
              tissue between what's discussed on a call and what gets acted on
              in the plant.
            </p>

            {/* Solution Overview Image */}
            <div className="mb-12 rounded-lg overflow-hidden shadow-xl max-w-sm mx-auto">
              <img
                src={jidokaCaseStudy1}
                alt="Jindo solution overview"
                className="w-full h-auto"
              />
            </div>

            {/* Capabilities List */}
            <div className="space-y-0">
              <div className="grid lg:grid-cols-[1fr_2fr] gap-6 py-6 border-t border-slate-300">
                <h3 className="text-lg font-bold text-slate-900">
                  Bot‑free capture
                </h3>
                <p className="text-slate-700">
                  Jindo invisibly transcribes technical calls in the
                  meeting, extracting the details that actually matter — camera
                  constraints, line speeds, lighting conditions — into
                  synthesized, searchable text instead of another video file to
                  archive.
                </p>
              </div>

              <div className="py-6 border-t border-slate-300">
                <div className="grid lg:grid-cols-[1fr_2fr] gap-6">
                  <h3 className="text-lg font-bold text-slate-900">
                    Built for the factory floor, not a boardroom
                  </h3>
                  <div>
                    <p className="text-slate-700 mb-4">
                      On a single call, presales and customers switch fluidly
                      between English and regional languages, often breaking into
                      side conversations of their own. Jindo is tuned for exactly
                      that kind of language switching, so plant requirements come
                      through accurately.
                    </p>
                    {/* <div className="flex flex-wrap gap-2 mb-6">
                      {[
                        "English",
                        "Tamil",
                        "Marathi",
                        "Hindi",
                        "German",
                        "Japanese",
                      ].map((lang) => (
                        <span
                          key={lang}
                          className="px-3 py-1 text-xs border border-black black"
                        >
                          {lang}
                        </span>
                      ))}
                    </div> */}
                    <div className="rounded-lg overflow-hidden shadow-lg max-w-md mx-auto">
                      <img
                        src={multilingualImage}
                        alt="Multilingual transcription"
                        className="w-full h-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid lg:grid-cols-[1fr_2fr] gap-6 py-6 border-t border-slate-300">
                <h3 className="text-lg font-bold text-slate-900">
                  Account history that shows up before the PM does
                </h3>
                <p className="text-slate-700">
                  Every commitment and objection from a sales call syncs
                  automatically into Zoho CRM and Gmail. Delivery PMs walk into
                  kickoff already knowing the account's history — nobody starts
                  cold.
                </p>
              </div>

              <div className="grid lg:grid-cols-[1fr_2fr] gap-6 py-6 border-t border-b border-slate-300">
                <h3 className="text-lg font-bold text-slate-900">
                  Pattern recognition across the whole pipeline
                </h3>
                <p className="text-slate-700">
                  Jindo's Teams layer surfaces patterns across every call the
                  presales team has had with every customer — recurring pushback
                  on lighting verification, requests for 2‑hour on‑site SLAs,
                  messaging that's resonating. Signal that used to live in one
                  rep's head is now visible to leadership early enough to act
                  on.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* The Impact */}
        <section className="py-16 sm:py-20 bg-gray-200 border-t border-slate-300">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
            <h2 className="text-3xl font-bold text-slate-900 mb-8">
              The Impact: delighted customers, effective delivery teams
            </h2>
             {/* Impact Image */}
            <div className="mb-12 rounded-lg overflow-hidden shadow-xl max-w-xl mx-auto">
              <img
                src={jidokaCaseStudy5}
                alt="Jindo impact on Jidoka's operations"
                className="w-full h-auto"
              />
            </div>
            <div className="space-y-0">
              <div className="grid lg:grid-cols-[1fr_2fr] gap-6 py-6 border-t border-slate-300">
                <h3 className="text-lg font-bold text-slate-900">
                  Delivery starts on day one
                </h3>
                <p className="text-slate-700">
                  With full technical context waiting in the CRM, Delivery
                  Managers skip the rediscovery phase entirely — deployment
                  starts where the sales conversation left off, not from zero.
                </p>
              </div>
              <div className="grid lg:grid-cols-[1fr_2fr] gap-6 py-6 border-t border-slate-300">
                <h3 className="text-lg font-bold text-slate-900">
                  The friction and the storage bill both disappeared
                </h3>
                <p className="text-slate-700">
                  No more bots in the room, no more objections from plant
                  executives, no more paying to store MP4 files nobody watches.
                  Technical memory now lives in lightweight, synthesized,
                  searchable text that's instantly accessible to engineering, globally and 24x7.
                </p>
              </div>
              <div className="grid lg:grid-cols-[1fr_2fr] gap-6 py-6 border-t border-b border-slate-300">
                <h3 className="text-lg font-bold text-slate-900">
                  Sales promises and delivery reality finally match
                </h3>
                <p className="text-slate-700">
                  Accurate multilingual data capture combined with cross‑account
                  pattern detection lets leadership see messaging drift in real
                  time, catch scope creep before it hits a POC contract, and keep the
                  pitch aligned with what plants actually desire.
                </p>
              </div>

            </div>

          </div>
        </section>

        {/* CTA */}
        <section className="bg-slate-900 text-white py-8 sm:py-12 mb-6">
          <div className="flex justify-around items-center align-center max-w-6xl px-2 sm:px-4 lg:px-8">
            <h2 className=" text-xl sm:text-2xl font-bold max-w-3xl">
              See how Jindo keeps every detail intact from call to shop floor.
            </h2>
            <button
              onClick={openWaitlistModal}
              className="inline-flex items-center justify-center rounded-full bg-jindo-orange text-white px-8 py-6 font-bold text-base leading-none shadow-lg hover:-translate-y-0.5 transition-transform"
            >
              Talk to us
            </button>
          </div>
        </section>
      </main>

      <Footer />

      <WaitlistModal
        showWaitlistModal={showWaitlistModal}
        closeWaitlistModal={closeWaitlistModal}
        formData={formData}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        isSubmitted={isSubmitted}
        formError={formError}
      />
    </div>
  );
};

export default CaseStudyDetail;
